// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chatLink.chatLink-url{color:var(--link-text)}", ""]);
// Exports
module.exports = exports;
